import React, { Component } from "react";
import PropTypes from "prop-types";
import { parse, stringify } from "qs";
import { throttle } from "lodash";
import SimpleHero from "~/scripts/components/SimpleHero";
import CaseStudiesFeatured from "~/scripts/components/case-studies/CaseStudiesFeatured";
import Articles from "~/scripts/components/case-studies/Articles";

class CaseStudies extends Component {
    static propTypes = {
        endpoint: PropTypes.string,
        pre: PropTypes.string,
        featured: PropTypes.object,
        applications: PropTypes.array
    };

    constructor(props) {
        super(props);

        this.state = {
            data: []
        };

        this.load = this.load.bind(this);
        this.loadMore = this.loadMore.bind(this);
        this.handleScroll = throttle(this.handleScroll.bind(this), 250);

        this.ref = React.createRef();
    }

    componentDidMount() {
        window.addEventListener("popstate", this.load);
        window.addEventListener("scroll", this.handleScroll);
        this.load();
    }

    componentWillUnmount() {
        window.removeEventListener("popstate", this.load);
        window.removeEventListener("scroll", this.handleScroll);
    }

    async load() {
        const { endpoint } = this.props;
        const { application: slug } = parse(window.location.search, {
            ignoreQueryPrefix: true,
            arrayFormat: "repeat"
        });

        this.setState({ loading: true, application: slug });

        const application = this.getApplication(slug);

        const url = application ? `${endpoint}/${application.id}` : endpoint;

        const response = await fetch(url);

        const body = await response.json();

        const {
            data,
            meta: { pagination }
        } = body;

        this.setState({ loading: false, data, pagination, application: slug });
    }

    getApplication = slug => {
        const { applications } = this.props;

        for (let item of applications) {
            if (item.slug === slug) {
                return item;
            }
        }
    };

    handleChange = value => {
        const search = stringify(
            { application: value },
            { addQueryPrefix: true, arrayFormat: "repeat" }
        );

        window.history.pushState(
            {},
            "",
            `${window.location.pathname}${search}`
        );

        this.load();
    };

    handleScroll() {
        const { loading, pagination } = this.state;

        if (
            loading ||
            !pagination ||
            pagination.current_page === pagination.total_pages ||
            !pagination.links ||
            !pagination.links.next
        ) {
            return;
        }

        const { bottom } = this.ref.current.getBoundingClientRect();
        const { innerHeight } = window;

        if (bottom - innerHeight / 2 <= innerHeight) {
            this.loadMore();
        }
    }

    async loadMore() {
        const {
            pagination: {
                links: { next }
            }
        } = this.state;

        this.setState({ loading: true });

        const response = await fetch(next);

        const body = await response.json();

        const {
            data,
            meta: { pagination }
        } = body;

        this.setState(prevState => {
            return {
                loading: false,
                data: [...prevState.data, ...data],
                pagination
            };
        });
    }

    render() {
        const { pre, featured, applications } = this.props;
        const { application, data, loading, pagination } = this.state;

        if (!data) {
            return null;
        }

        const showFeatured = !application;

        return (
            <div ref={this.ref}>
                <SimpleHero pre={pre} noFeatured={!showFeatured} />
                <CaseStudiesFeatured
                    showFeatured={showFeatured}
                    featured={featured}
                    applications={applications}
                    application={this.getApplication(application)}
                    onChange={this.handleChange}
                />
                <Articles
                    pagination={pagination}
                    data={data}
                    loading={loading}
                />
            </div>
        );
    }
}

export default CaseStudies;



// WEBPACK FOOTER //
// ./public/assets/scripts/components/CaseStudies.js